var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "left-right-panel-reveal-container block-container"
  }, [_vm._l(_vm.blocks, function (block, blockIndex) {
    return _c('div', {
      key: blockIndex,
      staticClass: "block",
      attrs: {
        "id": [("block-" + blockIndex)],
        "track-by": blockIndex
      }
    }, _vm._l(block, function (step, stepIndex) {
      return _c('div', {
        key: stepIndex,
        staticClass: "block-paragraph",
        attrs: {
          "track-by": stepIndex
        }
      }, [_c('blinking-cursor-text', {
        attrs: {
          "text": step.answer,
          "text-step": _vm.progress.stepIndex,
          "shouldBeCurrentStep": blockIndex === _vm.currentBlock && stepIndex === _vm.currentBlockStep,
          "shouldBeCompletedStep": blockIndex <= _vm.currentBlock && stepIndex < _vm.currentBlockStep
        }
      })], 1);
    }), 0);
  }), _c('div', {
    attrs: {
      "id": "img-overlay"
    }
  }, [_c('div', {
    attrs: {
      "id": "img-background"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])]), _c('div', {
    attrs: {
      "id": "end-instructions"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.endInstructions) + "\n        ")])], 2)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }